import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";

export default function AdminTransactions() {
  const [tx, setTx] = useState([]);
  useEffect(() => { api.get("/admin/transactions", adminApi()).then(({ data }) => setTx(data)); }, []);

  return (
    <div className="font-admin-body">
      <h1 className="font-admin-head text-3xl mb-6">Ödeme İşlemleri</h1>
      <div className="admin-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-white/50 uppercase tracking-wider">
            <tr className="border-b border-[#27272A]">
              <th className="p-3">Tarih</th><th className="p-3">E-posta</th><th className="p-3">Tür</th><th className="p-3">Ürün</th><th className="p-3">Tutar</th><th className="p-3">Durum</th>
            </tr>
          </thead>
          <tbody>
            {tx.map((t) => (
              <tr key={t.id} className="border-b border-[#18181B]" data-testid={`tx-${t.id}`}>
                <td className="p-3 text-xs text-white/60">{new Date(t.created_at).toLocaleString("tr-TR")}</td>
                <td className="p-3">{t.email}</td>
                <td className="p-3">{t.kind}</td>
                <td className="p-3">{t.package_slug || t.plan_slug || "-"}</td>
                <td className="p-3 tabular-nums">${t.amount} {t.currency}</td>
                <td className="p-3">
                  <span className={t.payment_status === "paid" ? "text-emerald-400" : t.payment_status === "expired" ? "text-red-400" : "text-white/50"}>
                    {t.payment_status}
                  </span>
                </td>
              </tr>
            ))}
            {tx.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-white/50">Henüz işlem yok</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
